import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorizationRequest } from '@core/model';
import { AuthenticationService, PASCompleteService } from '@core/service';
import { PortalProducts } from '@shared/enumeration';

@Component({
    selector: 'app-auth-request-completion',
    templateUrl: './auth-request-completion.component.html',
    styleUrls: ['./auth-request-completion.component.scss'],
    standalone: false
})
export class AuthRequestCompletionComponent implements OnInit {
  @Input() requestType: string;
  @Input() authRequest: AuthorizationRequest;
  @Input() isPASCompleteFlow: boolean;
  @Input() isHhAuthForPacUser = false;

  isExternalUser: boolean;
  tenantId: string;
  subscriberNumber: string;
  headerText: string;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private pasCompleteService: PASCompleteService,
  ) { }

  ngOnInit() {
    this.isExternalUser = this.authenticationService.isExternalUser;
    this.tenantId = this.route.snapshot.params.tenantId;
    this.subscriberNumber = this.route.snapshot.params.memberId;
    this.setHeaderText();
  }

  setHeaderText() {
    if (this.isHhAuthForPacUser) {
      this.headerText = `Home Health ${this.authRequest.authorizationDTO.authorizationNumber} Request has been submitted.`
    } else if (this.isExternalUser && !this.authRequest.authorizationDTO.isCurrentUserOwner) {
      this.headerText = `The authorization request has been submitted. Click a button below to return to Member Details or return to the Home Page.`;
    } else {
      this.headerText = `The authorization request ${this.authRequest.authorizationDTO.authorizationNumber} has been submitted.
      Click a button below to view the authorization request or return to this Home Page.`;
    }
  }

  navigateToAuthorizationDetails() {
    this.router.navigate([this.tenantId,'home-health', 'auth-dashboard', this.authRequest.authorizationDTO.authorizationNumber]);
  }

  navigateToOriginalAuthDetails() {
    const authorizationNumber = this.isHhAuthForPacUser
      ? this.pasCompleteService.authorizationNumberPac()
      : this.pasCompleteService.getOriginLoPACHHAuthNumber();

    this.router.navigate([this.tenantId, PortalProducts.PACIM, 'auth-dashboard', authorizationNumber]);
  }

  navigateToMemberDetails() {
    this.router.navigate([this.tenantId, 'member', this.subscriberNumber]);
  }

  navigateToHome() {
    this.router.navigate(['/home']);
  }
  
  navigateToProviderDashboard(): void {
    this.router.navigate(['/', this.tenantId, 'provider-dashboard']);
  }
}
